import apiRequest from "@/utils/apiRequest";
import { GET_ROLE_PERMISSIONS_URL } from "@/config/apiEndpoints";

export const state = {
  loading: false,
  rolePermission: null,
};

export const getters = {
  loading: (state) => state.loading,
  rolePermission: (state) => state.rolePermission,
};

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  STORE_ROLE_PERMISSIONS(state) {
    state.loading = true;
    state.rolePermission = null;
  },
  STORE_ROLE_PERMISSIONS_SUCCESS(state, rolePermissions) {
    state.loading = false;
    state.rolePermission = rolePermissions;
  },
  STORE_ROLE_PERMISSIONS_FAILED(state) {
    state.loading = false;
    state.rolePermission = null;
  },
};

export const actions = {
  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },
  fetchRolePermissions({ commit }, params) {
    commit("STORE_ROLE_PERMISSIONS");
    apiRequest({
      url: GET_ROLE_PERMISSIONS_URL,
      method: "GET",
      params: params,
    })
      .then((res) => {
        commit("STORE_ROLE_PERMISSIONS_SUCCESS", res.data);
      })
      .catch((err) => {
        commit("STORE_ROLE_PERMISSIONS_FAILED");
        console.log(err);
      });
  },
};
